export const routes = [{
  path: '/eixos',
  component: () =>
    import(/* webpackChunkName: "tema" */ './components/List'),
  name: 'eixo.list',
  meta: {
    requiresAuth: true
  }
}]
